
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  inject,
  signal,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { RoomInfo } from '@core/models/domains/room';
import { DatepickerService } from '@shared/services/datepicker.service';
import { MatButtonModule } from '@angular/material/button';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iho-pdp-roomlimits-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    DatepickerComponent,
    DatepickerDirective,
  ],
  templateUrl: './pdp-roomlimits-modal.component.html',
  styleUrls: ['./pdp-roomlimits-modal.component.scss'],
})
export class PdpRoomlimitsModalComponent implements OnInit {
  dialog = MatDialogRef;
  roomInfo!: RoomInfo;
  isHourly: boolean;
  nightsToStand: number;
  isInLimitRange: boolean;
  limitFrom: number;
  limitTo: number;
  startDate = signal('');
  endDate = signal('');
  month = signal('');
  datePickerService = inject(DatepickerService);
  isMobile: any = isPlatformBrowser(this.platformId)
    ? /Android|iPhone/.test(window.navigator.userAgent)
    : undefined;
  activatedRoute = inject(ActivatedRoute);
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public InfoService: HotelInfoUiService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialogRef: MatDialogRef<PdpRoomlimitsModalComponent>
  ) {
    this.roomInfo = data.roomInfo;
    this.isHourly = data.isHourly;
    this.nightsToStand = data.nightsToStand;
    this.limitFrom = data.limitFrom;
    this.limitTo = data.limitTo;
    this.isInLimitRange = data.isInLimitRange;
  }

  ngOnInit(): void {
    this.startDate.set(this.datePickerService._startDate());
    this.endDate.set(this.datePickerService._endDate());
    this.month.set(this.monthArray[+this.startDate().split('/')[1]]);
  }

  monthArray = [
    '',
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
  ];

  closeModal() {
    this.dialogRef.close();
  }

  changedate() {
    this.dialogRef.close();
  }
}
